"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeOccupancyPercentage = exports.computeOccupancyRate = void 0;
/**
 * How much of a cabinet's capacity is actually covered.
 *
 * The single definition shared by every occupancy figure of the product:
 * `filled / (filled + open)`. Both terms must be counted the same way —
 * weighted slots (an all-day slot counts for two half-days), never
 * reservations, since several substitutes may request the same slot.
 *
 * @param params.filledSlots - weighted slots that are covered
 * @param params.openSlots - weighted slots still uncovered
 * @returns the rate in `[0, 1]`, `0` when there is no capacity at all
 */
const computeOccupancyRate = ({ filledSlots, openSlots, }) => {
    const totalSlots = filledSlots + openSlots;
    if (totalSlots <= 0) {
        return 0;
    }
    return filledSlots / totalSlots;
};
exports.computeOccupancyRate = computeOccupancyRate;
/**
 * {@link computeOccupancyRate} as a whole percentage, for display.
 *
 * @param params.filledSlots - weighted slots that are covered
 * @param params.openSlots - weighted slots still uncovered
 * @returns the rate as an integer percentage between `0` and `100`
 */
const computeOccupancyPercentage = ({ filledSlots, openSlots, }) => Math.round(100 * (0, exports.computeOccupancyRate)({ filledSlots, openSlots }));
exports.computeOccupancyPercentage = computeOccupancyPercentage;
